import axios from 'axios';

import { TenantType } from 'admin/tenants/Tenants';
import { SearchRequest } from 'core/util/Search';

export interface Agency {
    id: number;
    active: boolean;
    name: string;
    apiKey: string;
    apiEnabled: boolean;
    moduleIDs: string[];
    requestsPerSecond: number;
    financeID: string;
    tenantType: TenantType;
    // credentialMatchStrategy
    logo: string;
    whiteLabeled: string;
    internalName?: string;
    fromName?: string;
    fromEmail?: string;
    agencyKey: string;
}

export enum FieldName {
    Id = '__admin_agency_id__',
    AgencyKey = '__admin_agency_agencyKey__',
    ApiKey = '__admin_agency_api_key__',
    InternalName = '__admin_agency_internalName__',
    Logo = '__admin_agency_logo__',
    Name = '__admin_agency_name__',
    WhiteLabeled = '__admin_agency_whitelabel__',
}

export const getAgencies = async (search?: SearchRequest, args?: any): Promise<Agency[]> => {
    const { data } = await axios.get('/api/agencies', { params: { search, args } });

    return data;
};

export const getAgency = async (agencyId: number, args?: any): Promise<Agency> => {
    const { data } = await axios.get(`/api/agencies/${agencyId}`, { params: { agencyId, args } });

    return data;
};
